<app-autocomplete-select
  placeholder="{{'search.all' | translate}}"
  [options]="options"
  [(ngModel)]="value"
  style="width: 100%">
</app-autocomplete-select>
